import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const LinkExpired = () => {
  return (
    <Dialog open aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">Your Link Got Expired, or it seems you have entered a Invalid Link</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">Please Visit your online hotline page Again.</DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default LinkExpired;
